import { capitalizeFirstLetter } from './letter';

export function formatTrackingProps(props: { [key: string]: any }) {
  return Object.entries(props).reduce((acc, [key, value]) => {
    return { ...acc, [capitalizeFirstLetter(key)]: value };
  }, {});
}
